export default __webpack_public_path__ + "static/scan-and-thru-solution-d419934b3c3e0f2440b9ab53b6a2f9e8.png";